import { render } from "./PatientFeedback.vue?vue&type=template&id=d108b1d0&scoped=true"
import script from "./PatientFeedback.vue?vue&type=script&lang=js"
export * from "./PatientFeedback.vue?vue&type=script&lang=js"

import "./PatientFeedback.vue?vue&type=style&index=0&id=d108b1d0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d108b1d0"]])

export default __exports__